import { ChannelTypes } from '../../../pages/ChannelPage/channelType'
import { GameScheduleCardType } from './gameScheduleType'

export const getViewerChannelSlug = (
  channelSlug: string,
  channelType: ChannelTypes,
  content: GameScheduleCardType,
  isRootDomain: string
) => {
  switch (channelType) {
    case ChannelTypes.association:
    case ChannelTypes.district:
    case ChannelTypes.league:
    case ChannelTypes.club:
    case ChannelTypes.event:
      return content.channelSlug
    case ChannelTypes.team:
      if(content.event?.type! == 'event') {
        return content.displayChannelSlug
      } else {
        return isRootDomain ? content.displayChannelSlug : channelSlug
      }
    default:
      return channelSlug
  }
}
